"use client";

import React, { createContext, useContext } from "react";

import { PurchaseAuth } from "@/types/shop";

const PurchaseAuthContext = createContext<PurchaseAuth | null>(null);

interface PurchaseAuthProviderProps {
  value: PurchaseAuth;
  children: React.ReactNode;
}

/**
 * Each route mounts the adapter appropriate for its surface (today: MFA on
 * `/{tenant}/shop`). Composition components below this provider read auth via
 * `usePurchaseAuth()` only.
 */
export function PurchaseAuthProvider({
  value,
  children,
}: PurchaseAuthProviderProps) {
  return (
    <PurchaseAuthContext.Provider value={value}>
      {children}
    </PurchaseAuthContext.Provider>
  );
}

export function usePurchaseAuth(): PurchaseAuth {
  const ctx = useContext(PurchaseAuthContext);
  if (!ctx) {
    throw new Error(
      "usePurchaseAuth must be used inside a <PurchaseAuthProvider>",
    );
  }
  return ctx;
}
